import { startUpload } from './FileUploadController';
import sendFileMessage from './sendFileMessage';

export default function (files, peer, currentSession) {
  const fileUploadPromise = startUpload(files, peer.jid, currentSession);
  fileUploadPromise.then((uploadStatus) => {
    sendFileMessage(uploadStatus, peer);
  });
}
